// ! registon
import reg1 from "../../photos/uzb_sam_reg1.webp";
import reg2 from "../../photos/uzb_sam_reg2.webp";
import reg3 from "../../photos/uzb_sam_reg3.webp";

// ! guremir
import guremir1 from "../../photos/uzb_sam_guremir1.webp";
import guremir2 from "../../photos/uzb_sam_guremir2.webp";
import guremir3 from "../../photos/uzb_sam_guremir3.webp";

// ! shohi zinda
import shohizinda1 from "../../photos/uzb_sam_shoh1.webp";
import shohizinda2 from "../../photos/uzb_sam_shoh2.webp";
import shohizinda3 from "../../photos/uzb_sam_shoh3.webp";

// ! bibi-xonim
import bibixonim1 from "../../photos/uzb_sam_bibi1.webp";
import bibixonim2 from "../../photos/uzb_sam_bibi2.webp";
import bibixonim3 from "../../photos/uzb_sam_bibi3.webp";

// ! ulug‘bek rasadxonasi
import ulugbek1 from "../../photos/uzb_sam_ulugbek1.webp";
import ulugbek2 from "../../photos/uzb_sam_ulugbek2.webp";
import ulugbek3 from "../../photos/uzb_sam_ulugbek3.webp";

// ! afrosiyob muzeyi
import afrosiyob1 from "../../photos/uzb_sam_afrosiyob1.webp";
import afrosiyob2 from "../../photos/uzb_sam_afrosiyob2.webp";
import afrosiyob3 from "../../photos/uzb_sam_afrosiyob3.webp";

const samarkand = {
    uz: {
        key: "samarkand",
        title: "Samarqand — Buyuk Ipak Yo‘lining yuragi",

        intro: `
Samarqand — dunyoning eng qadimiy shaharlaridan biri bo‘lib, 3000 yildan ortiq tarixga ega.
Bu shahar “Sharqning durdonasi” deb ataladi, chunki u ilm, savdo va madaniyat markazi bo‘lgan.
  `,

        history: `
Samarqand — insoniyat sivilizatsiyasining eng qadimiy markazlaridan biri bo‘lib, 3000 yildan ortiq tarixga ega.

Qadimda u Sog‘diyona davlatining poytaxti bo‘lgan va Sharq hamda G‘arbni bog‘lagan Buyuk Ipak Yo‘lining eng muhim tugunlaridan biri hisoblangan. Shu sababli bu yerda Xitoy, Hindiston, Fors, Arab va Yevropa savdogarlari uchrashgan.

Miloddan avvalgi IV asrda Aleksandr Makedonskiy Samarqandni bosib olgan va shahar yunon madaniyati bilan boyigan. Keyinchalik shahar turli imperiyalar — Kushonlar, Arab xalifaligi, Temuriylar qo‘l ostida rivojlangan.

Eng oltin davr Amir Temur (1370–1405) davriga to‘g‘ri keladi. U Samarqandni dunyoning eng go‘zal poytaxtiga aylantirishni maqsad qilgan va bu yerga Eron, Hindiston, Turkiya va boshqa davlatlardan eng yaxshi me’morlarni olib kelgan.

Ulug‘bek davrida Samarqand ilm-fan markaziga aylandi. Bu yerda dunyodagi eng yirik rasadxonalardan biri qurilib, yulduzlar katalogi tuzilgan.

Bugungi kunda Samarqand UNESCO merosi ro‘yxatida bo‘lib, “Sharqning durdonasi” deb ataladi.
`,
        sections: [
            {
                title: "Registon maydoni — Samarqand",

                content: `
Registon maydoni Samarqand shahrining eng buyuk tarixiy va me’moriy yodgorliklaridan biri bo‘lib, butun dunyoga mashhur islomiy me’morchilik durdonasidir.

Bu maskan asrlar davomida ilm-fan, ta’lim, savdo va madaniyat markazi bo‘lib kelgan. Buyuk Ipak yo‘lining eng muhim nuqtalaridan biri sifatida Registon Sharq va G‘arb sivilizatsiyalarini bog‘lagan.

Bugungi kunda Registon — Samarqandning yuragi, O‘zbekistonning esa eng yorqin ramzlaridan biri hisoblanadi.
    `,

                details: `
Registon maydoni uchta ulkan madrasa majmuasidan iborat bo‘lib, ular Temuriylar va keyingi davrlar ilmiy va madaniy hayotining markazi bo‘lgan:

- Ulug‘bek madrasasi (1417–1420) — buyuk astronom va hukmdor Mirzo Ulug‘bek tomonidan qurilgan. Bu yerda matematika, astronomiya va falsafa o‘qitilgan.
- Sherdor madrasasi (1619–1636) — o‘zining sher va quyosh tasvirli bezaklari bilan mashhur.
- Tilla-Qori madrasasi (1646–1660) — ichki oltin bezaklari va masjid funksiyasini ham bajargani bilan ajralib turadi.

Registon maydoni faqat madrasa emas, balki:
- ilmiy markaz
- davlat e’lonlari maydoni
- savdo va yig‘ilish joyi
- diniy-ma’rifiy markaz
bo‘lib xizmat qilgan.

Har bir g‘isht, har bir koshin o‘zida asrlar tarixini saqlaydi.
    `,

                facts: `
- Samarqand shahrining markazida joylashgan
- “Registon” so‘zi fors tilida “qumli joy” degan ma’noni anglatadi
- 3 ta ulkan tarixiy madrasa mavjud
- Ulug‘bek madrasasi XV asrga tegishli
- Sherdor va Tilla-Qori madrasalari XVII asrda qurilgan
- Buyuk Ipak yo‘lining eng muhim markazlaridan biri bo‘lgan
- Ilm-fan va astronomiya markazi hisoblangan
- Temuriylar davrining eng katta ilmiy markazlaridan biri
- UNESCO Jahon merosi ro‘yxatiga kiritilgan
- Har yili millionlab sayyohlar tashrif buyuradi
- Sharq me’morchiligining eng yuksak namunalaridan biri
- Koshin bezaklari dunyoda eng noyoblardan hisoblanadi
- Registon kechasi yoritilganda “cinematic world stage” ko‘rinishiga ega bo‘ladi
- Samarqandning eng fotografik joyi hisoblanadi
- O‘zbekistonning eng kuchli turizm brendi
    `,
                images: [reg1, reg2, reg3,]
            },

            {
                title: "Gur-e Amir maqbarasi — Samarqand",

                content: `
Gur-e Amir maqbarasi Samarqand shahrining eng muhim tarixiy va me’moriy yodgorliklaridan biri bo‘lib, Temuriylar davrining eng ulug‘ obidalaridan hisoblanadi.

Bu majmua buyuk sarkarda Amir Temur va uning avlodlari sharafiga qurilgan bo‘lib, u Sharq me’morchiligining eng yuksak namunalaridan biri sifatida dunyoga tanilgan.

Moviy gumbazi, nafis koshin bezaklari va ulkan peshtoqlari bilan Gur-e Amir Samarqandning “tarixiy yuragi” sifatida tasvirlanadi.
    `,

                details: `
Gur-e Amir dastlab 1403-yillarda Amir Temurning nevarasi Muhammad Sulton uchun qurila boshlagan. Keyinchalik Amir Temur vafot etgach, uning o‘zi ham shu maqbaraga dafn etilgan.

Bu joy Temuriylar sulolasining oilaviy maqbarasiga aylangan.

📌 Ichida dafn etilgan shaxslar:
- Amir Temur (Tamerlan)
- Mironshoh (o‘g‘li)
- Shohrux (o‘g‘li)
- Ulug‘bek (nabirasi, buyuk astronom)
- Muhammad Sulton (nabirasi)
- Sayyid Baraka (ruhoniy va ustoz)

📌 Arxitektura xususiyatlari:
- 35 metr balandlikdagi moviy gumbaz
- Marmar va koshin bezaklar
- Oltin suvi bilan ishlangan ichki dekoratsiya
- Qur’on oyatlari bilan bezatilgan devorlar
- Simmetrik va geometrik islomiy naqshlar

📌 Tarixiy ahamiyati:
- Temuriylar imperiyasining ramzi
- O‘rta Osiyo me’morchiligining eng yuqori cho‘qqisi
- Keyingi Hind va Eron me’morchiligiga kuchli ta’sir ko‘rsatgan
- “Mug‘al imperiyasi” me’morchiligiga asos bo‘lgan

📌 Qiziqarli jihat:
Gur-e Amir ichidagi akustika juda kuchli bo‘lib, hatto past ovoz ham butun zalda aniq eshitiladi.
    `,

                facts: [
                    "Samarqand shahrida joylashgan",
                    "XV asr boshlarida qurilgan",
                    "Amir Temur va Temuriylar sulolasining maqbarasi",
                    "Moviy gumbazi bilan dunyoga mashhur",
                    "Dastlab Muhammad Sulton uchun qurilgan",
                    "Keyinchalik Temur ham shu yerga dafn etilgan",
                    "Ulug‘bek ham shu maqbarada dafn etilgan",
                    "Ichida 6 dan ortiq tarixiy shaxs mavjud",
                    "Islom me’morchiligining eng muhim yodgorliklaridan biri",
                    "Sharqona koshin san’atining eng yuqori namunasi",
                    "Geometrik naqshlar bilan bezatilgan",
                    "Qur’on oyatlari devorlarga yozilgan",
                    "Moviy gumbaz 14 metr atrofida diametrga ega",
                    "Temuriylar imperiyasi qudratini ifodalaydi",
                    "Hindiston Taj Mahaliga ilhom bergan",
                    "Mug‘al me’morchiligiga katta ta’sir ko‘rsatgan",
                    "Samarqandning eng mashhur turistik joylaridan biri",
                    "Har yili millionlab sayyohlar tashrif buyuradi",
                    "Ichki akustikasi juda noyob",
                    "Kecha yoritilganda juda cinematic ko‘rinadi"
                ],

                images: [guremir1, guremir2, guremir3,]
            },

            {
                title: "Shohizinda majmuasi — Samarqand",

                content: `
Shohizinda majmuasi Samarqand shahrining eng muqaddas va eng go‘zal tarixiy yodgorliklaridan biridir.

Bu majmua “tirik podsho” ma’nosini bildiradi va u asrlar davomida ziyoratgoh sifatida mashhur bo‘lib kelgan. Shohizinda Islom me’morchiligining eng nafis va rang-barang koshin san’ati bilan bezatilgan majmualaridan biri hisoblanadi.

Bu joy faqat tarixiy obida emas, balki ma’naviy va diniy ahamiyatga ega muqaddas maskandir.
    `,

                details: `
Shohizinda majmuasi Afrosiyob tepaligi yonbag‘rida joylashgan bo‘lib, u bir necha asrlar davomida shakllangan.

📌 Afsonaga ko‘ra:
Shohizinda nomi Payg‘ambarimiz Muhammad (s.a.v.) amakivachchasi Qusam ibn Abbos bilan bog‘lanadi. U Samarqandga islomni yoyish uchun kelgan va shu yerda yashiringan holda tirik qolgan degan rivoyat bor.

📌 Majmua tarkibi:
Shohizinda 20 dan ortiq maqbara va ziyoratgohlardan iborat uzun yo‘lak shaklidagi kompleksdir.

Ularda Temuriylar davri amaldorlari, sarkardalari va olimlari dafn etilgan.

📌 Eng mashhur qabrlar:
- Qusam ibn Abbos maqbarasi
- Temuriylar davri malikalar maqbaralari
- Amir Temur qarindoshlari va amaldorlari qabrlari

📌 Arxitektura:
- Moviy, ko‘k va oq koshinlar
- Nozik geometrik va islimiy naqshlar
- Qur’on oyatlari yozilgan devorlar
- Tor, lekin chuqur tarixiy yo‘laklar
- Har bir maqbara o‘ziga xos dizayn

Shohizinda majmuasi asrlar davomida qayta-qayta qurilgan va kengaytirilgan bo‘lib, har bir davr o‘z izini qoldirgan.
    `,

                facts: [
                    "Samarqand shahrida Afrosiyob yonida joylashgan",
                    "Shohizinda nomi “Tirik podsho” degan ma’noni anglatadi",
                    "20 dan ortiq maqbaralardan iborat majmua",
                    "Qusam ibn Abbos shu yerda dafn etilgan deb hisoblanadi",
                    "Islom olamida muqaddas ziyoratgohlardan biri",
                    "Temuriylar davrida eng muhim qabriston bo‘lgan",
                    "XI–XV asrlar davomida shakllangan",
                    "Moviy koshin san’atining eng yuqori namunasi",
                    "Har bir maqbara alohida me’moriy uslubga ega",
                    "Qur’on oyatlari bilan bezatilgan",
                    "Afrosiyob qadimiy shahri yonida joylashgan",
                    "Samarqandning eng ko‘p ziyorat qilinadigan joylaridan biri",
                    "UNESCO Jahon merosi ro‘yxatiga kiritilgan",
                    "Temuriylar malikalarining qabrlari mavjud",
                    "Koshin ranglari juda yorqin va saqlanib qolgan",
                    "Majmua bir necha asr davomida qurilgan",
                    "Tor yo‘lakli arxitekturaga ega",
                    "Diniy va tarixiy ahamiyati juda yuqori",
                    "Samarqandning eng fotogenik joylaridan biri",
                    "Kechasi yoritilganda juda cinematic ko‘rinadi"
                ],

                images: [shohizinda1, shohizinda2, shohizinda3,]
            },

            {
                title: "Bibi-Xonim masjidi — Samarqand",

                content: `
Bibi-Xonim masjidi Samarqand shahrining eng yirik va mashhur tarixiy obidalaridan biridir.

Bu masjid Amir Temur davrida qurilgan bo‘lib, o‘z davrida islom olamidagi eng ulkan jome masjidlardan biri hisoblangan.

Bugungi kunda Bibi-Xonim masjidi Samarqandning eng muhim turistik va tarixiy maskanlaridan biri sifatida qadrlanadi.
    `,

                details: `
Bibi-Xonim masjidi XIV asr oxiri — XV asr boshlarida Amir Temur buyrug‘i bilan Hindistonga qilgan yurishidan so‘ng qurila boshlangan.

📌 Afsonaga ko‘ra:
Masjid Temurning rafiqasi Saroy Mulk Xonim (Bibi-Xonim) sharafiga qurilgan.

📌 Arxitektura:
- Ulkan peshtoqlar
- Moviy koshinlar
- Marmar ustunlar
- Katta ichki hovli
- Gigant gumbazlar

📌 Tarixiy ahamiyati:
- O‘z davrida eng katta jome masjid bo‘lgan
- Temuriylar imperiyasining qudratini ifodalagan
- Sharq me’morchiligining yuksak namunasi hisoblangan

Vaqt o‘tishi bilan zilzilalar va tabiat ta’siri sababli masjid qisman yemirilgan, ammo uning ulug‘vor qoldiqlari hanuzgacha saqlanib qolgan.
    `,

                facts: [
                    "Samarqand shahrida joylashgan",
                    "Amir Temur davrida qurilgan",
                    "XV asr boshlarida bunyod etilgan",
                    "O‘z davrida eng katta jome masjidlardan biri bo‘lgan",
                    "Saroy Mulk Xonim sharafiga atalgan",
                    "Temur Hindiston yurishidan keyin qurdirgan",
                    "Ulkan peshtoqlari bilan mashhur",
                    "Moviy koshinlar bilan bezatilgan",
                    "Zilzilalar sabab qisman vayron bo‘lgan",
                    "Temuriylar me’morchiligining yorqin namunasi",
                    "Ichki hovlisi juda katta bo‘lgan",
                    "O‘sha davrda minglab namozxonlarni sig‘dira olgan",
                    "Sharq me’morchiligida muhim o‘rin tutadi",
                    "Samarqandning eng mashhur tarixiy joylaridan biri",
                    "Bugungi kunda restavratsiya qilingan",
                    "Turistlar uchun eng ko‘p tashrif buyuriladigan maskanlardan biri",
                    "UNESCO meros obidalari orasida tilga olinadi",
                    "Temur imperiyasining qudratini ko‘rsatgan",
                    "Katta gumbaz va minora qoldiqlari saqlangan",
                    "Samarqandning tarixiy ramzlaridan biri"
                ],

                images: [bibixonim1, bibixonim2, bibixonim3,]
            },

            {
                title: "Ulug‘bek rasadxonasi — Samarqand",

                content: `
Ulug‘bek rasadxonasi Samarqand shahrining eng muhim ilmiy va tarixiy yodgorliklaridan biridir.

Bu rasadxona XV asrda buyuk olim, astronom va hukmdor Mirzo Ulug‘bek tomonidan qurilgan bo‘lib, o‘sha davrda dunyoning eng ilg‘or ilmiy markazlaridan biri hisoblangan.

Ulug‘bek rasadxonasi Sharq ilm-fani va astronomiyasining yuksak darajasini ifodalovchi noyob obida hisoblanadi.
    `,

                details: `
Ulug‘bek rasadxonasi 1420-yillar atrofida Samarqand yaqinidagi Ko‘hak tepaligida qurilgan.

📌 Ilmiy ahamiyati:
Bu yerda osmon jismlari, yulduzlar harakati va sayyoralarning joylashuvi o‘rganilgan. Ulug‘bek va uning olimlari juda aniq astronomik jadvallar tuzishgan.

📌 Eng mashhur asar:
“Zij-i Sultoni” — Ulug‘bek rasadxonasida yaratilgan eng muhim astronomik kataloglardan biri bo‘lib, unda minglab yulduzlar joylashuvi aniq hisoblangan.

📌 Rasadxona tuzilishi:
- Ulkan yerosti sekstant (astronomik asbob)
- Doira shaklidagi bino
- Aniqlik uchun maxsus yo‘nalishlar
- Yulduzlarni kuzatish uchun maxsus yo‘laklar

📌 Tarix:
Keyinchalik rasadxona buzib tashlangan, ammo uning qoldiqlari 20-asrda qayta topilgan va muzeyga aylantirilgan.
    `,

                facts: [
                    "Samarqand shahrida Ko‘hak tepaligida joylashgan",
                    "XV asrda Mirzo Ulug‘bek tomonidan qurilgan",
                    "Dunyoning eng yirik ilmiy markazlaridan biri bo‘lgan",
                    "Astronomik kuzatuvlar uchun mo‘ljallangan",
                    "Yerosti katta sekstantga ega bo‘lgan",
                    "‘Zij-i Sultoni’ asari shu yerda yaratilgan",
                    "Yulduzlar jadvali juda aniq hisoblangan",
                    "O‘sha davr ilm-fanining eng yuqori cho‘qqisi",
                    "Keyinchalik buzib tashlangan",
                    "20-asrda qoldiqlari qayta topilgan",
                    "Bugungi kunda muzey sifatida saqlanadi",
                    "Ulug‘bek dunyoga mashhur astronom hisoblanadi",
                    "Islomiy ilm-fan markazi bo‘lgan",
                    "Osmon jismlarini o‘rganish markazi edi",
                    "Aniq matematik hisob-kitoblar ishlatilgan",
                    "O‘sha davr uchun juda ilg‘or texnologiya bo‘lgan",
                    "Samarqandning eng muhim ilmiy yodgorligi",
                    "UNESCO meros obidalari bilan bog‘liq hududda joylashgan",
                    "Sharq astronomiya tarixining eng muhim markazi",
                    "Bugungi kunda sayyohlar uchun ochiq muzey"
                ],
                images: [ulugbek1, ulugbek2, ulugbek3,]
            },

            {
                title: "Afrosiyob muzeyi — Samarqand",

                content: `
Afrosiyob muzeyi Samarqand shahrining eng qadimiy tarixini o‘zida saqlab qolgan arxeologik va tarixiy muzeydir.

Muzey Afrosiyob qadimiy shaharchasi hududida joylashgan bo‘lib, u Samarqandning 2700+ yillik tarixini ochib beradigan eng muhim ilmiy markazlardan biridir.

Bu yerda qadimiy Sog‘diyona davlati, Buyuk Ipak yo‘li davri va qadimiy Samarqand hayoti haqida noyob ma’lumotlar saqlanadi.
    `,

                details: `
Afrosiyob muzeyi 1970-yilda tashkil etilgan bo‘lib, Afrosiyob tepaligi (qadimiy Samarqand shahri xarobalari) yonida qurilgan.

Muzey eksponatlari miloddan avvalgi davrlardan XIII asrgacha bo‘lgan Samarqand tarixini yoritadi.

📌 Eng muhim topilmalar:
- Qadimiy sopol idishlar va kulolchilik buyumlari
- Tangalar, qurol-yarog‘lar va metall buyumlar
- Zardushtiylik davriga oid ossuariylar (suyak idishlari)
- Qadimiy devor bezaklari va arxitektura bo‘laklari
- Afrosiyob saroy freskalari (devor rasmlari)

📌 Mashhur freskalar:
Muzeyning eng qimmatli qismi — VII–VIII asrlarga tegishli “Elchilar freskalari” (Ambassadors paintings) hisoblanadi.

Bu freskalarda:
- Sog‘d hukmdori Varxuman tasvirlangan
- Xitoy, Eron, Hindiston va boshqa elchilar sahnalari aks etgan
- Tantanali yurishlar, sovg‘a almashish marosimlari ko‘rsatilgan
- Ov sahnalari va saroy hayoti tasvirlangan

📌 Freskalar haqida:
Bu devor rasmlari Afrosiyob saroyining asl ichki devorlaridan topilgan bo‘lib, Sog‘d san’atining eng noyob namunasi hisoblanadi. Ular Markaziy Osiyoda saqlanib qolgan eng qadimiy rangli devor rasmlaridan biridir.

📌 Arxeologik ahamiyati:
- Qazilmalar 1965-yilda tasodifan topilgan
- Afrosiyob hududi qadimiy Samarqandning markazi bo‘lgan
- Muzey butun shahar tarixini qatlamma-qatlam ko‘rsatadi
    `,

                facts: [
                    "Samarqand shahrida Afrosiyob tepaligi yonida joylashgan",
                    "1970-yilda tashkil etilgan",
                    "Qadimiy Samarqand tarixini o‘rganish markazi",
                    "2700 yildan ortiq shahar tarixini qamrab oladi",
                    "Afrosiyob shahri XIII asrda mo‘g‘ullar tomonidan vayron qilingan",
                    "Eng mashhur eksponat — VII–VIII asr freskalari",
                    "‘Elchilar freskalari’ dunyoga mashhur san’at asari",
                    "Sog‘diyona sivilizatsiyasiga oid buyumlar saqlanadi",
                    "Ossuariylar (zardushtiy suyak idishlari) topilgan",
                    "Tangalar, qurol va sopol buyumlar mavjud",
                    "Buyuk Ipak yo‘li davriga oid materiallar bor",
                    "Arxeologik qazilmalar 1965-yilda boshlangan",
                    "Afrosiyob qadimiy Samarqand markazi bo‘lgan",
                    "Freskalar Xitoy, Hindiston va Eron aloqalarini ko‘rsatadi",
                    "Samarqandning eng muhim muzeylaridan biri",
                    "Ichida 20 000 dan ortiq artefaktlar saqlanadi",
                    "Sog‘d san’atining eng noyob namunalari bor",
                    "Qadimiy saroy devor rasmlari asl joyida ko‘rsatiladi",
                    "Markaziy Osiyodagi eng muhim arxeologik muzeylardan biri",
                    "UNESCO merosi bilan bog‘liq hududda joylashgan"
                ],

                images: [
                    afrosiyob1,
                    afrosiyob2,
                    afrosiyob3,
                ]
            }
        ]

    },

    ru: {
        key: "samarkand",
        title: "Самарканд — сердце Великого Шёлкового пути",

        intro: `
Самарканд — один из древнейших городов мира с историей, насчитывающей более 3000 лет.
Этот город называют «Жемчужиной Востока», поскольку на протяжении веков он был крупнейшим центром науки, торговли и культуры.
`,

        history: `
Самарканд — один из древнейших центров человеческой цивилизации, история которого насчитывает более трёх тысячелетий.

В древности он был столицей государства Согдиана и являлся одним из важнейших узлов Великого Шёлкового пути, соединявшего Восток и Запад. Благодаря этому здесь встречались торговцы из Китая, Индии, Персии, Арабского мира и Европы.

В IV веке до нашей эры Самарканд был завоёван Александром Македонским, после чего город испытал значительное влияние греческой культуры. Позже он развивался под властью различных государств и империй — Кушанского царства, Арабского халифата и династии Тимуридов.

Наивысшего расцвета Самарканд достиг во времена Амира Темура (1370–1405). Он стремился превратить город в одну из самых прекрасных столиц мира и приглашал сюда лучших архитекторов, мастеров и учёных из Персии, Индии, Турции и других стран.

Во времена Мирзо Улугбека Самарканд стал одним из ведущих научных центров мира. Именно здесь была построена одна из крупнейших обсерваторий своего времени и составлен знаменитый каталог звёзд.

Сегодня Самарканд входит в Список всемирного наследия ЮНЕСКО и по праву считается одной из величайших жемчужин Востока.
`,

        sections: [
            {
                title: "Площадь Регистан — Самарканд",

                content: `
Площадь Регистан является одним из величайших исторических и архитектурных памятников Самарканда и признана во всём мире шедевром исламской архитектуры.

На протяжении многих веков это место служило центром науки, образования, торговли и культуры. Будучи одним из важнейших узлов Великого Шёлкового пути, Регистан соединял цивилизации Востока и Запада.

Сегодня Регистан считается сердцем Самарканда и одним из главных символов Узбекистана.
`,

                details: `
Архитектурный ансамбль Регистана состоит из трёх величественных медресе, которые были центром научной и культурной жизни эпохи Тимуридов и последующих периодов.

- Медресе Улугбека (1417–1420) — построено великим астрономом и правителем Мирзо Улугбеком. Здесь преподавались математика, астрономия и философия.
- Медресе Шердор (1619–1636) — известно своими уникальными изображениями львов и солнца на фасаде.
- Медресе Тилля-Кари (1646–1660) — знаменито роскошным позолоченным интерьером и тем, что одновременно выполняло функции мечети.

Регистан был не только образовательным центром, но и:

- научным центром;
- местом объявления государственных указов;
- торговой площадью;
- религиозно-просветительским центром.

Каждый кирпич и каждая мозаика здесь хранят многовековую историю.
`,

                facts: `
- Расположен в самом центре Самарканда
- Название «Регистан» в переводе с персидского означает «песчаное место»
- Комплекс состоит из трёх величественных исторических медресе
- Медресе Улугбека относится к XV веку
- Медресе Шердор и Тилля-Кари были построены в XVII веке
- Один из важнейших центров Великого Шёлкового пути
- Исторический центр науки и астрономии
- Один из крупнейших научных центров эпохи Тимуридов
- Включён в Список всемирного наследия ЮНЕСКО
- Ежегодно его посещают миллионы туристов
- Один из величайших шедевров восточной архитектуры
- Уникальные керамические и мозаичные украшения считаются одними из лучших в мире
- В вечерней подсветке Регистан выглядит как кинематографическая мировая сцена
- Одно из самых фотографируемых мест Самарканда
- Один из главных туристических символов Узбекистана
`,
                images: [reg1, reg2, reg3]
            },
            // ! guremir
            {
                title: "Мавзолей Гур-Эмир — Самарканд",

                content: `
Мавзолей Гур-Эмир — один из важнейших исторических и архитектурных памятников Самарканда, считающийся одним из величайших шедевров эпохи Тимуридов.

Этот архитектурный комплекс был построен в честь великого полководца Амира Темура и его потомков и признан во всём мире одним из выдающихся образцов восточной исламской архитектуры.

Благодаря своему величественному голубому куполу, изысканной мозаике и монументальному порталу Гур-Эмир по праву называют «историческим сердцем» Самарканда.
`,

                details: `
Строительство мавзолея Гур-Эмир началось в 1403 году для любимого внука Амира Темура — Мухаммада Султана. После смерти самого Амира Темура он также был похоронен именно здесь.

Позже мавзолей стал семейной усыпальницей династии Тимуридов.

📌 Здесь покоятся:

- Амир Темур (Тамерлан)
- Мираншах (сын)
- Шахрух (сын)
- Мирзо Улугбек (внук, великий астроном)
- Мухаммад Султан (внук)
- Саид Барака (духовный наставник)

📌 Архитектурные особенности:

- Голубой купол высотой около 35 метров
- Богатая отделка из мрамора и глазурованной керамики
- Роскошный интерьер с позолотой
- Стены украшены аятами Священного Корана
- Симметричные геометрические орнаменты исламского искусства

📌 Историческое значение:

- Один из главных символов империи Тимуридов
- Вершина архитектуры Центральной Азии
- Оказал огромное влияние на архитектуру Персии и Индии
- Считается одним из источников вдохновения для архитектуры Империи Великих Моголов

📌 Интересный факт:

Мавзолей обладает уникальной акустикой — даже тихий голос отчётливо слышен во всём зале.
`,

                facts: [
                    "Расположен в городе Самарканд",
                    "Построен в начале XV века",
                    "Является мавзолеем Амира Темура и династии Тимуридов",
                    "Всемирно известен своим голубым куполом",
                    "Изначально строился для Мухаммада Султана",
                    "Позже здесь был похоронен и сам Амир Темур",
                    "Мирзо Улугбек также покоится в этом мавзолее",
                    "Здесь захоронены более шести исторических личностей",
                    "Один из важнейших памятников исламской архитектуры",
                    "Выдающийся образец восточного искусства мозаики",
                    "Украшен сложными геометрическими орнаментами",
                    "Стены украшены аятами Священного Корана",
                    "Диаметр голубого купола составляет около 14 метров",
                    "Символизирует могущество империи Тимуридов",
                    "Считается источником вдохновения для мавзолея Тадж-Махал в Индии",
                    "Оказал большое влияние на архитектуру Империи Великих Моголов",
                    "Одно из самых известных туристических мест Самарканда",
                    "Ежегодно принимает миллионы туристов",
                    "Обладает уникальной внутренней акустикой",
                    "В вечерней подсветке выглядит особенно впечатляюще и кинематографично"
                ],

                images: [guremir1, guremir2, guremir3],
            },

            {
                title: "Комплекс Шахи-Зинда — Самарканд",

                content: `
Комплекс Шахи-Зинда — один из самых священных и красивых исторических памятников Самарканда.

Название комплекса переводится как «Живой царь», и на протяжении многих веков он является одним из самых почитаемых мест паломничества. Шахи-Зинда считается одним из выдающихся шедевров исламской архитектуры, известным своими изысканными и яркими керамическими мозаиками.

Это не только исторический памятник, но и священное место, обладающее огромным духовным и религиозным значением.
`,

                details: `
Комплекс Шахи-Зинда расположен на склоне холма Афросиаб и формировался на протяжении нескольких столетий.

📌 Согласно легенде:

Название Шахи-Зинда связано с Кусамом ибн Аббасом — двоюродным братом Пророка Мухаммада (мир ему и благословение). Согласно преданию, он прибыл в Самарканд для распространения ислама и чудесным образом остался жив, скрывшись в этом месте.

📌 Состав комплекса:

Шахи-Зинда представляет собой длинный архитектурный ансамбль, включающий более 20 мавзолеев и священных усыпальниц.

Здесь покоятся представители династии Тимуридов, государственные деятели, полководцы и выдающиеся учёные.

📌 Наиболее известные мавзолеи:

- Мавзолей Кусама ибн Аббаса
- Усыпальницы принцесс эпохи Тимуридов
- Захоронения родственников и приближённых Амира Темура

📌 Архитектурные особенности:

- Голубая, синяя и белая керамическая мозаика
- Изящные геометрические и растительные орнаменты
- Стены, украшенные аятами Священного Корана
- Узкие, но глубокие исторические проходы
- Каждый мавзолей обладает уникальным архитектурным стилем

На протяжении веков комплекс неоднократно расширялся и перестраивался, поэтому каждая эпоха оставила здесь свой неповторимый след.
`,

                facts: [
                    "Расположен рядом с древним городищем Афросиаб в Самарканде",
                    "Название «Шахи-Зинда» означает «Живой царь»",
                    "Комплекс включает более 20 мавзолеев",
                    "Считается, что здесь похоронен Кусам ибн Аббас",
                    "Одно из самых священных мест паломничества исламского мира",
                    "Во времена Тимуридов являлся главным некрополем",
                    "Формировался с XI по XV век",
                    "Выдающийся образец искусства голубой керамической мозаики",
                    "Каждый мавзолей выполнен в собственном архитектурном стиле",
                    "Стены украшены аятами Священного Корана",
                    "Расположен рядом с древним городом Афросиаб",
                    "Одно из самых посещаемых мест Самарканда",
                    "Включён в Список всемирного наследия ЮНЕСКО",
                    "Здесь находятся мавзолеи принцесс эпохи Тимуридов",
                    "Яркие керамические узоры прекрасно сохранились до наших дней",
                    "Комплекс строился и расширялся на протяжении нескольких столетий",
                    "Отличается уникальной архитектурой узких проходов",
                    "Обладает огромным религиозным и историческим значением",
                    "Одно из самых фотогеничных мест Самарканда",
                    "В вечерней подсветке выглядит особенно эффектно и кинематографично"
                ],

                images: [shohizinda1, shohizinda2, shohizinda3],
            },
            {
                title: "Мечеть Биби-Ханым — Самарканд",

                content: `
Мечеть Биби-Ханым — один из крупнейших и самых известных исторических памятников Самарканда.

Она была построена во времена Амира Темура и в своё время считалась одной из самых грандиозных соборных мечетей исламского мира.

Сегодня мечеть Биби-Ханым является одной из главных исторических достопримечательностей и важнейших туристических символов Самарканда.
`,

                details: `
Строительство мечети Биби-Ханым началось в конце XIV — начале XV века по приказу Амира Темура после его победоносного похода в Индию.

📌 Согласно легенде:

Мечеть была названа в честь супруги Амира Темура — Сарой Мульк Ханым (Биби-Ханым).

📌 Архитектурные особенности:

- Величественные порталы
- Голубые керамические мозаики
- Мраморные колонны
- Просторный внутренний двор
- Огромные купола

📌 Историческое значение:

- В своё время была крупнейшей соборной мечетью Центральной Азии
- Символизировала могущество империи Тимуридов
- Считается выдающимся шедевром восточной исламской архитектуры

Со временем из-за землетрясений и природных факторов мечеть была частично разрушена, однако её величественные руины сохранились до наших дней и были частично восстановлены.
`,

                facts: [
                    "Расположена в городе Самарканд",
                    "Построена во времена Амира Темура",
                    "Возведена в начале XV века",
                    "Когда-то была одной из крупнейших соборных мечетей исламского мира",
                    "Названа в честь Сарой Мульк Ханым (Биби-Ханым)",
                    "Построена после индийского похода Амира Темура",
                    "Известна своими величественными порталами",
                    "Украшена голубыми керамическими мозаиками",
                    "Частично разрушена в результате землетрясений",
                    "Выдающийся памятник архитектуры эпохи Тимуридов",
                    "Обладает просторным внутренним двором",
                    "В прошлом могла вместить тысячи верующих",
                    "Занимает важное место в истории восточной архитектуры",
                    "Одна из самых известных исторических достопримечательностей Самарканда",
                    "В настоящее время частично реставрирована",
                    "Является одной из самых посещаемых туристических достопримечательностей",
                    "Упоминается среди объектов Всемирного наследия ЮНЕСКО",
                    "Ярко отражает могущество империи Тимуридов",
                    "Сохранились остатки огромного купола и минаретов",
                    "Является одним из исторических символов Самарканда"
                ],

                images: [bibixonim1, bibixonim2, bibixonim3],
            },
            {
                title: "Обсерватория Улугбека — Самарканд",

                content: `
Обсерватория Улугбека — один из важнейших научных и исторических памятников Самарканда.

Она была построена в XV веке великим учёным, астрономом и правителем Мирзо Улугбеком и считалась одним из самых передовых научных центров своего времени.

Обсерватория Улугбека является уникальным памятником, символизирующим высокий уровень развития науки и астрономии на Востоке.
`,

                details: `
Обсерватория Улугбека была построена приблизительно в 1420-х годах на холме Кухак недалеко от Самарканда.

📌 Научное значение:

Здесь проводились наблюдения за небесными телами, движением звёзд и расположением планет. Улугбек и его учёные составили исключительно точные астрономические таблицы.

📌 Самый известный труд:

«Зидж-и Султани» — один из важнейших астрономических каталогов, созданных в обсерватории Улугбека, в котором с высокой точностью были определены координаты тысяч звёзд.

📌 Устройство обсерватории:

- Огромный подземный секстант (астрономический инструмент)
- Здание круглой формы
- Специальные направления для точных измерений
- Особые проходы для наблюдения за звёздным небом

📌 История:

Позднее обсерватория была разрушена, однако её остатки были вновь обнаружены в XX веке, после чего на этом месте был открыт музей.
`,

                facts: [
                    "Расположена на холме Кухак в Самарканде",
                    "Построена Мирзо Улугбеком в XV веке",
                    "Была одним из крупнейших научных центров своего времени",
                    "Предназначалась для астрономических наблюдений",
                    "Оснащена огромным подземным секстантом",
                    "Именно здесь был создан труд «Зидж-и Султани»",
                    "Астрономические таблицы отличались исключительной точностью",
                    "Являлась вершиной науки своей эпохи",
                    "Позднее была разрушена",
                    "Остатки были обнаружены в XX веке",
                    "Сегодня функционирует как музей",
                    "Мирзо Улугбек признан одним из величайших астрономов мира",
                    "Была важнейшим центром исламской науки",
                    "Здесь изучались небесные тела и космические явления",
                    "Использовались исключительно точные математические расчёты",
                    "Для своего времени являлась передовым научным сооружением",
                    "Один из важнейших научных памятников Самарканда",
                    "Находится на территории, связанной с объектами Всемирного наследия ЮНЕСКО",
                    "Один из важнейших центров истории восточной астрономии",
                    "Сегодня открыта для посещения туристами как музей"
                ],

                images: [ulugbek1, ulugbek2, ulugbek3],
            },

            {
                title: "Музей Афросиаб — Самарканд",

                content: `
Музей Афросиаб — археологический и исторический музей, хранящий богатейшее наследие древнейшего Самарканда.

Музей расположен на территории древнего городища Афросиаб и является одним из важнейших научных центров, раскрывающих более чем 2700-летнюю историю Самарканда.

Здесь представлены уникальные материалы, посвящённые древнему государству Согдиана, эпохе Великого Шёлкового пути и повседневной жизни древнего Самарканда.
`,

                details: `
Музей Афросиаб был основан в 1970 году рядом с холмом Афросиаб — местом расположения руин древнего Самарканда.

Экспозиция музея охватывает историю Самарканда от древнейших времён до XIII века.

📌 Наиболее ценные находки:

- Древняя керамика и изделия гончарного искусства
- Монеты, оружие и металлические предметы
- Оссуарии (зороастрийские сосуды для хранения костей)
- Фрагменты древних архитектурных сооружений и декоративных элементов
- Фрески дворца Афросиаба

📌 Знаменитые фрески:

Главной ценностью музея считаются «Фрески послов», датируемые VII–VIII веками.

На них изображены:

- Согдийский правитель Вархуман
- Послы из Китая, Персии, Индии и других государств
- Торжественные процессии и церемонии обмена дарами
- Сцены охоты и придворной жизни

📌 О фресках:

Эти настенные росписи были обнаружены на внутренних стенах дворца Афросиаба и считаются одним из самых выдающихся произведений согдийского искусства. Они входят в число древнейших сохранившихся цветных настенных росписей Центральной Азии.

📌 Археологическое значение:

- Археологические раскопки были случайно обнаружены в 1965 году
- Территория Афросиаба являлась центром древнего Самарканда
- Экспозиция музея последовательно раскрывает историю города через различные исторические эпохи
`,

                facts: [
                    "Расположен рядом с холмом Афросиаб в Самарканде",
                    "Основан в 1970 году",
                    "Является главным музеем по изучению истории древнего Самарканда",
                    "Охватывает более 2700 лет истории города",
                    "Древний Афросиаб был разрушен монголами в XIII веке",
                    "Самый известный экспонат — фрески VII–VIII веков",
                    "«Фрески послов» являются всемирно известным произведением искусства",
                    "Хранятся артефакты цивилизации Согдианы",
                    "Обнаружены зороастрийские оссуарии",
                    "Представлены монеты, оружие и керамические изделия",
                    "Содержит материалы эпохи Великого Шёлкового пути",
                    "Археологические раскопки начались в 1965 году",
                    "Афросиаб был историческим центром древнего Самарканда",
                    "Фрески свидетельствуют о связях с Китаем, Индией и Персией",
                    "Один из важнейших музеев Самарканда",
                    "В музее хранится более 20 000 археологических артефактов",
                    "Представлены уникальные образцы согдийского искусства",
                    "Оригинальные дворцовые настенные росписи экспонируются на месте находки",
                    "Один из важнейших археологических музеев Центральной Азии",
                    "Расположен на территории, связанной с объектами Всемирного наследия ЮНЕСКО"
                ],

                images: [
                    afrosiyob1,
                    afrosiyob2,
                    afrosiyob3,
                ]
            },
        ]
    },

    en: {
        key: "samarkand",

        title: "Samarkand — The Heart of the Great Silk Road",

        intro: `
Samarkand is one of the oldest cities in the world, boasting a history of more than 3,000 years.

Known as the "Pearl of the East," the city has long been a center of science, trade, and culture.
`,

        history: `
Samarkand is one of the oldest centers of human civilization, with a history spanning more than 3,000 years.

In ancient times, it served as the capital of Sogdiana and became one of the most important crossroads of the Great Silk Road, connecting East and West. Merchants from China, India, Persia, Arabia, and Europe gathered here to exchange goods, ideas, and cultures.

In the 4th century BC, Alexander the Great conquered Samarkand, introducing elements of Greek culture. Over the centuries, the city flourished under various empires, including the Kushans, the Arab Caliphate, and the Timurids.

Its greatest golden age came during the reign of Amir Temur (Tamerlane) between 1370 and 1405. Determined to make Samarkand the most magnificent capital in the world, he invited the finest architects and craftsmen from Persia, India, Anatolia, and many other regions.

Under the rule of Mirzo Ulugh Beg, Samarkand became one of the world's leading scientific centers. One of the largest observatories of its time was built here, where an extraordinary star catalogue was compiled.

Today, Samarkand is recognized as a UNESCO World Heritage Site and proudly known as the "Pearl of the East."
`,

        sections: [
            {
                title: "Registan Square — Samarkand",

                content: `
Registan Square is one of the greatest historical and architectural masterpieces of Samarkand and one of the world's most celebrated monuments of Islamic architecture.

For centuries, it served as a center of science, education, commerce, and culture. As one of the most important stops along the Great Silk Road, Registan connected the civilizations of East and West.

Today, Registan is considered the heart of Samarkand and one of Uzbekistan's most iconic national symbols.
`,

                details: `
Registan Square consists of three magnificent madrasahs that once served as the intellectual and cultural center of the Timurid era and later periods.

- Ulugh Beg Madrasah (1417–1420) — built by the great astronomer and ruler Mirzo Ulugh Beg, where mathematics, astronomy, and philosophy were taught.
- Sher-Dor Madrasah (1619–1636) — famous for its unique tiger-and-sun mosaics.
- Tilla-Kari Madrasah (1646–1660) — renowned for its lavish golden interior and functioning as both a madrasa and a mosque.

Registan was much more than a religious school. It served as:

- A scientific center
- A public square for royal announcements
- A marketplace and gathering place
- A religious and educational center

Every brick and every tile preserves centuries of history.
`,

                facts: [
                    "Located in the heart of Samarkand",
                    "The word 'Registan' means 'sandy place' in Persian",
                    "Home to three magnificent historic madrasahs",
                    "Ulugh Beg Madrasah dates back to the 15th century",
                    "Sher-Dor and Tilla-Kari Madrasahs were built in the 17th century",
                    "One of the most important hubs of the Great Silk Road",
                    "A major center of science and astronomy",
                    "One of the greatest scientific centers of the Timurid Empire",
                    "Listed as a UNESCO World Heritage Site",
                    "Welcomes millions of visitors every year",
                    "One of the finest masterpieces of Eastern Islamic architecture",
                    "Its ceramic tilework is considered among the world's most remarkable",
                    "Illuminated at night, it offers a spectacular cinematic atmosphere",
                    "One of the most photographed places in Samarkand",
                    "One of Uzbekistan's strongest tourism symbols"
                ],

                images: [reg1, reg2, reg3],
            },
            {
                title: "Gur-e Amir Mausoleum — Samarkand",

                content: `
The Gur-e Amir Mausoleum is one of Samarkand's most significant historical and architectural landmarks, regarded as one of the greatest masterpieces of Timurid architecture.

Built in honor of the great conqueror Amir Temur (Tamerlane) and his descendants, the mausoleum is recognized worldwide as one of the finest examples of Islamic architecture in Central Asia.

With its magnificent turquoise dome, elegant mosaic decorations, and monumental entrance portal, Gur-e Amir is often described as the historical heart of Samarkand.
`,

                details: `
Construction of the Gur-e Amir Mausoleum began in 1403 for Muhammad Sultan, the beloved grandson of Amir Temur. After Amir Temur's death, he was also laid to rest here.

The mausoleum later became the royal burial place of the Timurid dynasty.

📌 Those buried here include:

- Amir Temur (Tamerlane)
- Miranshah (his son)
- Shah Rukh (his son)
- Mirzo Ulugh Beg (his grandson and the famous astronomer)
- Muhammad Sultan (his grandson)
- Sayyid Baraka (his spiritual mentor)

📌 Architectural Highlights:

- A magnificent turquoise dome standing approximately 35 meters high
- Exquisite marble and glazed tile decorations
- Rich interior adorned with gold leaf
- Walls decorated with verses from the Holy Qur'an
- Elegant geometric patterns representing Islamic art

📌 Historical Importance:

- One of the greatest symbols of the Timurid Empire
- A masterpiece of Central Asian architecture
- Influenced later Persian and Indian architecture
- Considered one of the inspirations behind Mughal architecture, including the Taj Mahal

📌 Interesting Fact:

The mausoleum is famous for its remarkable acoustics—even a quiet voice can be heard clearly throughout the entire chamber.
`,

                facts: [
                    "Located in Samarkand",
                    "Built in the early 15th century",
                    "The mausoleum of Amir Temur and the Timurid dynasty",
                    "World-famous for its magnificent turquoise dome",
                    "Originally built for Muhammad Sultan",
                    "Later became the burial place of Amir Temur himself",
                    "Mirzo Ulugh Beg is also buried here",
                    "More than six historical figures are buried inside",
                    "One of the finest monuments of Islamic architecture",
                    "A masterpiece of traditional Central Asian tilework",
                    "Decorated with intricate geometric patterns",
                    "The walls are adorned with verses from the Holy Qur'an",
                    "The dome has a diameter of approximately 14 meters",
                    "A symbol of the power of the Timurid Empire",
                    "Believed to have inspired the design of India's Taj Mahal",
                    "Had a significant influence on Mughal architecture",
                    "One of the most visited attractions in Samarkand",
                    "Receives millions of visitors every year",
                    "Known for its exceptional interior acoustics",
                    "Beautifully illuminated at night with a cinematic atmosphere"
                ],

                images: [guremir1, guremir2, guremir3],
            },
            
            {
                title: "Shah-i-Zinda Complex — Samarkand",

                content: `
The Shah-i-Zinda Complex is one of the holiest and most beautiful historical monuments in Samarkand.

Its name means "The Living King," and for centuries it has been one of the region's most revered pilgrimage sites. Shah-i-Zinda is celebrated as one of the finest masterpieces of Islamic architecture, renowned for its breathtaking blue ceramic mosaics and intricate decorative craftsmanship.

More than just a historical monument, it is a sacred place of profound spiritual and religious significance.
`,

                details: `
The Shah-i-Zinda Complex is located on the slopes of the ancient Afrosiab hill and gradually developed over several centuries.

📌 According to legend:

The name Shah-i-Zinda is associated with Qutham ibn Abbas, a cousin of the Prophet Muhammad (peace be upon him). According to tradition, he came to Samarkand to spread Islam and miraculously remained alive after hiding in this sacred place.

📌 The Complex:

Shah-i-Zinda is a long architectural ensemble consisting of more than 20 mausoleums and sacred shrines.

Many members of the Timurid dynasty, high-ranking officials, military commanders, and distinguished scholars were buried here.

📌 Most Famous Tombs:

- Mausoleum of Qutham ibn Abbas
- Mausoleums of Timurid princesses
- Tombs of Amir Temur's relatives and prominent officials

📌 Architectural Highlights:

- Brilliant blue, turquoise, and white ceramic tiles
- Delicate geometric and floral Islamic ornaments
- Walls decorated with verses from the Holy Qur'an
- Narrow yet historically rich passageways
- Every mausoleum features its own distinctive architectural style

Over the centuries, the complex was repeatedly expanded and restored, allowing each historical era to leave its unique architectural legacy.
`,

                facts: [
                    "Located near the ancient city of Afrosiab in Samarkand",
                    "The name 'Shah-i-Zinda' means 'The Living King'",
                    "Consists of more than 20 mausoleums",
                    "Believed to be the burial place of Qutham ibn Abbas",
                    "One of the holiest pilgrimage sites in the Islamic world",
                    "Served as the principal necropolis during the Timurid era",
                    "Developed between the 11th and 15th centuries",
                    "A masterpiece of blue ceramic tile craftsmanship",
                    "Each mausoleum has its own unique architectural style",
                    "Decorated with verses from the Holy Qur'an",
                    "Situated beside the ancient settlement of Afrosiab",
                    "One of the most visited attractions in Samarkand",
                    "Included in the UNESCO World Heritage Site",
                    "Contains the mausoleums of Timurid princesses",
                    "Its vibrant ceramic decorations have been remarkably preserved",
                    "Constructed and expanded over several centuries",
                    "Famous for its unique narrow-passage architecture",
                    "Holds exceptional religious and historical importance",
                    "One of the most photogenic places in Samarkand",
                    "Spectacularly illuminated at night with a cinematic atmosphere"
                ],

                images: [shohizinda1, shohizinda2, shohizinda3],
            },

            {
                title: "Bibi-Khanym Mosque — Samarkand",

                content: `
The Bibi-Khanym Mosque is one of the largest and most famous historical monuments in Samarkand.

Built during the reign of Amir Temur (Tamerlane), it was once regarded as one of the largest congregational mosques in the Islamic world.

Today, the Bibi-Khanym Mosque stands as one of Samarkand's most important historical landmarks and a symbol of Uzbekistan's rich architectural heritage.
`,

                details: `
Construction of the Bibi-Khanym Mosque began in the late 14th and early 15th centuries by the order of Amir Temur following his victorious campaign in India.

📌 According to legend:

The mosque was dedicated to Amir Temur's beloved wife, Saray Mulk Khanum, better known as Bibi-Khanym.

📌 Architectural Highlights:

- Monumental entrance portals
- Magnificent blue ceramic mosaics
- Elegant marble columns
- A vast central courtyard
- Massive domes that dominate the skyline

📌 Historical Significance:

- Once the largest congregational mosque in Central Asia
- A powerful symbol of the greatness of the Timurid Empire
- One of the finest masterpieces of Islamic architecture in the East

Over the centuries, earthquakes and natural disasters caused significant damage to the mosque. Nevertheless, its magnificent remains have survived, and extensive restoration work has preserved much of its former glory.
`,

                facts: [
                    "Located in Samarkand",
                    "Built during the reign of Amir Temur",
                    "Constructed in the early 15th century",
                    "Once one of the largest congregational mosques in the Islamic world",
                    "Named after Saray Mulk Khanum (Bibi-Khanym)",
                    "Commissioned after Amir Temur's Indian campaign",
                    "Famous for its monumental entrance portals",
                    "Decorated with stunning blue ceramic mosaics",
                    "Partially damaged by powerful earthquakes",
                    "A masterpiece of Timurid architecture",
                    "Features an enormous central courtyard",
                    "Once accommodated thousands of worshippers",
                    "Holds an important place in the history of Islamic architecture",
                    "One of Samarkand's most iconic historical attractions",
                    "Carefully restored in modern times",
                    "One of the city's most visited tourist destinations",
                    "Part of the UNESCO World Heritage Site of Samarkand",
                    "Reflects the power and ambition of the Timurid Empire",
                    "Remains of its grand dome and minarets can still be seen",
                    "One of the historical symbols of Samarkand"
                ],

                images: [bibixonim1, bibixonim2, bibixonim3],
            },

            {
                title: "Ulugh Beg Observatory — Samarkand",

                content: `
The Ulugh Beg Observatory is one of Samarkand's most significant scientific and historical landmarks.

Built in the 15th century by the renowned scholar, astronomer, and ruler Mirzo Ulugh Beg, it was considered one of the most advanced astronomical research centers in the world.

Today, the observatory stands as a remarkable monument reflecting the extraordinary achievements of science and astronomy in the Islamic Golden Age.
`,

                details: `
The Ulugh Beg Observatory was constructed around the 1420s on Kuhak Hill, just outside Samarkand.

📌 Scientific Significance:

Astronomers at the observatory carefully studied celestial bodies, the movement of stars, and the positions of planets. Under Ulugh Beg's leadership, scholars produced some of the most accurate astronomical tables of their time.

📌 Most Famous Work:

The "Zij-i Sultani" is one of the most important astronomical catalogs ever compiled. Created at the observatory, it accurately recorded the positions of thousands of stars and became a landmark achievement in the history of astronomy.

📌 Observatory Structure:

- A massive underground sextant used for astronomical measurements
- A circular architectural design
- Precisely aligned observation points
- Specialized passageways for observing the night sky

📌 History:

The observatory was later destroyed, but its remains were rediscovered during the 20th century. Today, the site has been preserved as a museum dedicated to Ulugh Beg's scientific legacy.
`,

                facts: [
                    "Located on Kuhak Hill in Samarkand",
                    "Built by Mirzo Ulugh Beg in the 15th century",
                    "One of the world's leading scientific centers of its time",
                    "Designed for advanced astronomical observations",
                    "Contained a massive underground sextant",
                    "The famous 'Zij-i Sultani' was compiled here",
                    "Its star catalog achieved remarkable accuracy",
                    "Represented the peak of scientific achievement during its era",
                    "Destroyed in later centuries",
                    "Its remains were rediscovered in the 20th century",
                    "Today preserved as a museum",
                    "Ulugh Beg is recognized as one of history's greatest astronomers",
                    "An important center of Islamic science",
                    "Dedicated to the study of celestial bodies",
                    "Advanced mathematical calculations were carried out here",
                    "Featured cutting-edge technology for its time",
                    "One of Samarkand's most important scientific landmarks",
                    "Located within the UNESCO World Heritage area",
                    "One of the most significant sites in the history of Eastern astronomy",
                    "Open to visitors as a museum today"
                ],

                images: [ulugbek1, ulugbek2, ulugbek3],
            },
            {
                title: "Afrasiab Museum — Samarkand",

                content: `
The Afrasiab Museum is an archaeological and historical museum preserving the oldest history of Samarkand.

Located beside the ruins of the ancient city of Afrasiab, the museum is one of the most important scientific institutions revealing more than 2,700 years of Samarkand's history.

Visitors can explore unique artifacts related to the ancient Sogdian civilization, the Silk Road, and everyday life in ancient Samarkand.
`,

                details: `
The Afrasiab Museum was established in 1970 and built next to Afrasiab Hill, the archaeological site of ancient Samarkand.

Its collections present the history of Samarkand from ancient times until the 13th century.

📌 Major Discoveries:
- Ancient pottery and ceramic artifacts
- Coins, weapons, and metal objects
- Zoroastrian ossuaries (bone containers)
- Architectural fragments and decorative elements
- The famous Afrasiab Palace murals

📌 Famous Murals:
The museum's most valuable treasures are the 7th–8th century "Ambassadors' Murals."

These murals depict:
- King Varkhuman of Sogdiana
- Delegations from China, Persia, India, and other countries
- Ceremonial processions and diplomatic gift exchanges
- Hunting scenes and palace life

📌 About the Murals:
These original wall paintings were discovered inside the Afrasiab Palace and are regarded as masterpieces of Sogdian art. They are among the oldest surviving colored murals in Central Asia.

📌 Archaeological Importance:
- Excavations began after an accidental discovery in 1965
- Afrasiab was the ancient center of Samarkand
- The museum presents the city's history layer by layer through archaeological evidence
`,

                facts: [
                    "Located beside Afrasiab Hill in Samarkand",
                    "Established in 1970",
                    "Dedicated to the study of ancient Samarkand",
                    "Covers more than 2,700 years of history",
                    "Ancient Afrasiab was destroyed by the Mongols in the 13th century",
                    "Best known for its 7th–8th century murals",
                    "The 'Ambassadors' Murals' are internationally renowned",
                    "Preserves artifacts from the Sogdian civilization",
                    "Contains Zoroastrian ossuaries",
                    "Displays coins, weapons, and ceramic objects",
                    "Exhibits related to the Silk Road",
                    "Archaeological excavations began in 1965",
                    "Afrasiab was the original site of ancient Samarkand",
                    "The murals illustrate relations with China, India, and Persia",
                    "One of Samarkand's most important museums",
                    "Houses more than 20,000 artifacts",
                    "Features outstanding examples of Sogdian art",
                    "Original palace wall paintings are displayed",
                    "One of Central Asia's leading archaeological museums",
                    "Located within the UNESCO World Heritage zone"
                ],

                images: [
                    afrosiyob1,
                    afrosiyob2,
                    afrosiyob3,
                ]
            },
        ]
    },

    fr: {
        key: "samarkand",
        title: "Samarcande — Le cœur de la Grande Route de la Soie",

        intro: `
Samarcande est l'une des plus anciennes villes du monde, avec plus de 3 000 ans d'histoire.

Surnommée la « Perle de l'Orient », elle fut pendant des siècles un centre majeur de savoir, de commerce et de culture.
`,

        history: `
Samarcande est l'un des plus anciens foyers de civilisation de l'humanité et possède plus de trois millénaires d'histoire.

Dans l'Antiquité, elle était la capitale de la Sogdiane et l'un des carrefours les plus importants de la Grande Route de la Soie reliant l'Orient et l'Occident. Des marchands venus de Chine, d'Inde, de Perse, du monde arabe et d'Europe s'y rencontraient pour échanger marchandises, idées et cultures.

Au IVe siècle avant J.-C., Alexandre le Grand conquit Samarcande, apportant avec lui l'influence de la civilisation hellénistique. Au fil des siècles, la ville prospéra sous différentes puissances, notamment les Kouchans, le Califat arabe et l'Empire timouride.

Son âge d'or débuta sous le règne d'Amir Timur (Tamerlan) entre 1370 et 1405. Désireux de faire de Samarcande la plus belle capitale du monde, il fit venir les meilleurs architectes, artisans et artistes de Perse, d'Inde, d'Anatolie et d'autres régions.

Sous le règne de Mirzo Ulugh Beg, Samarcande devint également un centre scientifique de renommée mondiale. L'un des plus grands observatoires astronomiques de son époque y fut construit et un remarquable catalogue d'étoiles y fut élaboré.

Aujourd'hui, Samarcande est inscrite au patrimoine mondial de l'UNESCO et demeure l'un des plus précieux joyaux de l'Orient.
`,

        sections: [
            {
                title: "La place du Régistan — Samarcande",

                content: `
La place du Régistan est l'un des monuments historiques et architecturaux les plus emblématiques de Samarcande. Véritable chef-d'œuvre de l'architecture islamique, elle est reconnue dans le monde entier.

Pendant des siècles, elle fut un centre de savoir, d'enseignement, de commerce et de culture. Située sur l'un des principaux axes de la Grande Route de la Soie, elle reliait les civilisations de l'Orient et de l'Occident.

Aujourd'hui, le Régistan est considéré comme le cœur de Samarcande et l'un des symboles les plus prestigieux de l'Ouzbékistan.
`,

                details: `
La place du Régistan est composée de trois magnifiques médersas qui furent les principaux centres scientifiques et culturels de l'époque timouride et des siècles suivants.

- Médersa d'Oulough Beg (1417–1420) — fondée par le grand astronome et souverain Mirzo Ulugh Beg, où étaient enseignées les mathématiques, l'astronomie et la philosophie.
- Médersa Cher-Dor (1619–1636) — célèbre pour ses décorations représentant des lions et des soleils.
- Médersa Tilla-Kari (1646–1660) — réputée pour ses somptueux décors dorés et sa mosquée intégrée.

Le Régistan n'était pas seulement un complexe religieux. Il servait également de :
- centre scientifique
- place des proclamations officielles
- marché et lieu de rassemblement
- centre religieux et éducatif

Chaque brique et chaque mosaïque racontent plusieurs siècles d'histoire.
`,

                facts: `
- Situé au cœur de Samarcande
- Le mot « Régistan » signifie « lieu sablonneux » en persan
- Composé de trois médersas monumentales
- La médersa d'Oulough Beg date du XVe siècle
- Les médersas Cher-Dor et Tilla-Kari furent construites au XVIIe siècle
- L'un des plus importants carrefours de la Route de la Soie
- Important centre scientifique et astronomique
- L'un des plus grands centres intellectuels de l'époque timouride
- Inscrit au patrimoine mondial de l'UNESCO
- Accueille chaque année des millions de visiteurs
- L'un des plus beaux chefs-d'œuvre de l'architecture orientale
- Célèbre pour ses mosaïques parmi les plus raffinées au monde
- Illuminé la nuit, le Régistan offre un décor spectaculaire digne d'un film
- L'un des lieux les plus photographiés de Samarcande
- Le symbole touristique le plus emblématique de l'Ouzbékistan
`,

                images: [reg1, reg2, reg3],
            },

            {
                title: "Le mausolée Gour Emir — Samarcande",

                content: `
Le mausolée Gour Emir est l'un des monuments historiques et architecturaux les plus emblématiques de Samarcande. Il est considéré comme l'un des plus grands chefs-d'œuvre de l'époque timouride.

Construit en l'honneur du grand conquérant Amir Timur (Tamerlan) et de ses descendants, ce monument est reconnu dans le monde entier comme l'un des sommets de l'architecture orientale.

Avec son majestueux dôme bleu, ses délicates mosaïques et son imposant portail, Gour Emir est souvent décrit comme le « cœur historique » de Samarcande.
`,

                details: `
La construction du mausolée débuta en 1403 pour le petit-fils d'Amir Timur, Muhammad Sultan. Après la mort de Timur, celui-ci y fut également inhumé.

Le monument devint ensuite le mausolée familial de la dynastie timouride.

📌 Personnalités inhumées :
- Amir Timur (Tamerlan)
- Miran Shah (son fils)
- Shah Rukh (son fils)
- Mirzo Ulugh Beg (son petit-fils et grand astronome)
- Muhammad Sultan (petit-fils)
- Sayyid Baraka (guide spirituel et maître religieux)

📌 Caractéristiques architecturales :
- Un dôme bleu de 35 mètres de hauteur
- Des décorations en marbre et en mosaïques
- Une riche décoration intérieure recouverte de feuilles d'or
- Des murs ornés de versets du Coran
- Des motifs géométriques et islamiques parfaitement symétriques

📌 Importance historique :
- Symbole de l'Empire timouride
- L'un des plus grands chefs-d'œuvre architecturaux d'Asie centrale
- A profondément influencé l'architecture perse et indienne
- A servi d'inspiration à l'architecture de l'Empire moghol

📌 Fait remarquable :
L'acoustique intérieure du mausolée est exceptionnelle : même une voix très basse peut être entendue clairement dans toute la salle.
`,

                facts: [
                    "Situé à Samarcande",
                    "Construit au début du XVe siècle",
                    "Mausolée d'Amir Timur et de la dynastie timouride",
                    "Célèbre dans le monde entier pour son dôme bleu",
                    "Construit à l'origine pour Muhammad Sultan",
                    "Amir Timur y fut ensuite inhumé",
                    "Mirzo Ulugh Beg repose également dans ce mausolée",
                    "Abrite les tombes de plus de six personnages historiques",
                    "L'un des plus importants monuments de l'architecture islamique",
                    "Chef-d'œuvre de l'art de la mosaïque orientale",
                    "Décoré de magnifiques motifs géométriques",
                    "Les murs sont ornés de versets coraniques",
                    "Le dôme bleu mesure environ 14 mètres de diamètre",
                    "Symbole de la puissance de l'Empire timouride",
                    "A inspiré la construction du Taj Mahal en Inde",
                    "A exercé une grande influence sur l'architecture moghole",
                    "L'un des sites touristiques les plus célèbres de Samarcande",
                    "Accueille chaque année des millions de visiteurs",
                    "Réputé pour son acoustique exceptionnelle",
                    "Magnifiquement illuminé la nuit, offrant un décor spectaculaire"
                ],

                images: [guremir1, guremir2, guremir3],
            },

            {
                title: "Le complexe de Shah-i-Zinda — Samarcande",

                content: `
Le complexe de Shah-i-Zinda est l'un des monuments les plus sacrés et les plus remarquables de Samarcande.

Son nom signifie « Le Roi Vivant » et, depuis des siècles, ce lieu est un important site de pèlerinage. Shah-i-Zinda est considéré comme l'un des plus beaux ensembles de l'architecture islamique, célèbre pour ses magnifiques mosaïques aux couleurs éclatantes.

Bien plus qu'un simple monument historique, Shah-i-Zinda est un lieu sacré d'une grande importance spirituelle et religieuse.
`,

                details: `
Le complexe de Shah-i-Zinda est situé sur les pentes de la colline d'Afrasiab et s'est développé au fil de plusieurs siècles.

📌 Selon la légende :
Le nom Shah-i-Zinda est associé à Qutham ibn Abbas, cousin du Prophète Mohammed (paix et bénédictions sur lui). Selon la tradition, il serait venu à Samarcande pour diffuser l'islam et aurait miraculeusement survécu en se cachant, ce qui lui valut le surnom de « Roi Vivant ».

📌 Composition du complexe :
Shah-i-Zinda est un long ensemble composé de plus de vingt mausolées et sanctuaires.

De nombreux membres de la noblesse, des commandants militaires et des érudits de l'époque timouride y furent inhumés.

📌 Les tombeaux les plus célèbres :
- Mausolée de Qutham ibn Abbas
- Mausolées des princesses timourides
- Tombes des proches et des hauts dignitaires d'Amir Timur

📌 Architecture :
- Magnifiques mosaïques bleues, turquoise et blanches
- Motifs géométriques et arabesques d'une grande finesse
- Murs décorés de versets du Coran
- Couloirs étroits chargés d'histoire
- Chaque mausolée possède son propre style architectural

Le complexe de Shah-i-Zinda a été agrandi et restauré à plusieurs reprises au cours des siècles, chaque époque y laissant son empreinte.
`,

                facts: [
                    "Situé près d'Afrasiab à Samarcande",
                    "Le nom Shah-i-Zinda signifie « Le Roi Vivant »",
                    "Ensemble composé de plus de vingt mausolées",
                    "On pense que Qutham ibn Abbas y est enterré",
                    "L'un des lieux de pèlerinage les plus sacrés du monde islamique",
                    "Principal cimetière de l'époque timouride",
                    "Construit entre le XIe et le XVe siècle",
                    "Magnifique exemple de l'art des mosaïques bleues",
                    "Chaque mausolée possède un style architectural unique",
                    "Les murs sont décorés de versets coraniques",
                    "Situé à proximité de l'ancienne cité d'Afrasiab",
                    "L'un des sites les plus visités de Samarcande",
                    "Inscrit au patrimoine mondial de l'UNESCO",
                    "Abrite les tombeaux des princesses timourides",
                    "Ses mosaïques ont conservé leurs couleurs éclatantes",
                    "Le complexe s'est développé sur plusieurs siècles",
                    "Connu pour ses passages étroits et son architecture unique",
                    "Possède une importance historique et spirituelle exceptionnelle",
                    "L'un des lieux les plus photogéniques de Samarcande",
                    "Magnifiquement illuminé à la nuit tombée"
                ],

                images: [shohizinda1, shohizinda2, shohizinda3],
            },

            {
                title: "La mosquée Bibi-Khanym — Samarcande",

                content: `
La mosquée Bibi-Khanym est l'un des monuments historiques les plus imposants et les plus célèbres de Samarcande.

Construite sous le règne d'Amir Timur (Tamerlan), elle était considérée à son époque comme l'une des plus grandes mosquées du monde islamique.

Aujourd'hui, la mosquée Bibi-Khanym demeure l'un des sites historiques et touristiques les plus prestigieux de Samarcande.
`,

                details: `
La construction de la mosquée Bibi-Khanym débuta à la fin du XIVe siècle et au début du XVe siècle, sur ordre d'Amir Timur, après son retour de sa campagne militaire en Inde.

📌 Selon la légende :
La mosquée aurait été édifiée en l'honneur de l'épouse de Timur, Saray Mulk Khanum, plus connue sous le nom de Bibi-Khanym.

📌 Architecture :
- Un portail monumental
- De magnifiques mosaïques bleues
- Des colonnes en marbre
- Une vaste cour intérieure
- D'immenses coupoles

📌 Importance historique :
- L'une des plus grandes mosquées de son époque
- Symbole de la puissance de l'Empire timouride
- Un chef-d'œuvre exceptionnel de l'architecture orientale

Au fil des siècles, les tremblements de terre et les effets du temps ont partiellement endommagé la mosquée, mais ses vestiges majestueux témoignent encore aujourd'hui de sa grandeur.
`,

                facts: [
                    "Située à Samarcande",
                    "Construite sous le règne d'Amir Timur",
                    "Édifiée au début du XVe siècle",
                    "L'une des plus grandes mosquées de son époque",
                    "Dédiée à Saray Mulk Khanum (Bibi-Khanym)",
                    "Construite après la campagne de Timur en Inde",
                    "Célèbre pour son immense portail d'entrée",
                    "Décorée de magnifiques mosaïques bleues",
                    "Partiellement endommagée par plusieurs tremblements de terre",
                    "Chef-d'œuvre de l'architecture timouride",
                    "Possède une vaste cour intérieure",
                    "Pouvait accueillir des milliers de fidèles",
                    "Occupe une place majeure dans l'architecture orientale",
                    "L'un des monuments historiques les plus célèbres de Samarcande",
                    "Entièrement restaurée en grande partie",
                    "L'un des sites les plus visités par les touristes",
                    "Mentionnée parmi les monuments du patrimoine mondial de l'UNESCO",
                    "Symbolise la puissance de l'Empire timouride",
                    "Une partie de ses grandes coupoles et de ses minarets est encore conservée",
                    "L'un des symboles historiques de Samarcande"
                ],

                images: [bibixonim1, bibixonim2, bibixonim3],
            },

            {
                title: "Observatoire d'Oulough Beg — Samarcande",

                content: `
L'Observatoire d'Oulough Beg est l'un des monuments scientifiques et historiques les plus importants de Samarcande.

Construit au XVe siècle par le grand savant, astronome et souverain Mirzo Oulough Beg, il était considéré comme l'un des centres scientifiques les plus avancés du monde à son époque.

L'observatoire représente un témoignage exceptionnel du haut niveau de l'astronomie et des sciences en Orient.
`,

                details: `
L'Observatoire d'Oulough Beg fut construit vers les années 1420 sur la colline de Kouhak, près de Samarcande.

📌 Importance scientifique :
C'est ici que furent étudiés les corps célestes, le mouvement des étoiles et la position des planètes. Oulough Beg et son équipe de savants réalisèrent des calculs astronomiques d'une précision remarquable.

📌 L'œuvre la plus célèbre :
Le "Zij-i Sultani", l'un des catalogues astronomiques les plus importants de son époque, fut élaboré dans cet observatoire et répertoria avec précision des milliers d'étoiles.

📌 Structure de l'observatoire :
- Un immense sextant souterrain (instrument astronomique)
- Un bâtiment circulaire
- Des axes spécialement conçus pour des observations précises
- Des galeries destinées à l'observation des étoiles

📌 Histoire :
L'observatoire fut détruit plusieurs années plus tard, mais ses vestiges furent redécouverts au XXe siècle puis transformés en musée.
`,

                facts: [
                    "Situé sur la colline de Kouhak à Samarcande",
                    "Construit au XVe siècle par Mirzo Oulough Beg",
                    "Était l'un des plus grands centres scientifiques du monde",
                    "Conçu pour les observations astronomiques",
                    "Possédait un immense sextant souterrain",
                    "Le « Zij-i Sultani » y fut rédigé",
                    "Son catalogue d'étoiles était d'une précision exceptionnelle",
                    "Représentait le sommet de la science de son époque",
                    "Fut détruit par la suite",
                    "Ses vestiges furent retrouvés au XXe siècle",
                    "Est aujourd'hui conservé comme musée",
                    "Oulough Beg est reconnu comme l'un des plus grands astronomes de l'histoire",
                    "Était un centre majeur des sciences islamiques",
                    "Consacré à l'étude des corps célestes",
                    "Utilisait des calculs mathématiques extrêmement précis",
                    "Représentait une technologie très avancée pour son époque",
                    "L'un des monuments scientifiques les plus importants de Samarcande",
                    "Situé dans une zone liée au patrimoine mondial de l'UNESCO",
                    "L'un des centres les plus importants de l'histoire de l'astronomie orientale",
                    "Aujourd'hui ouvert aux visiteurs en tant que musée"
                ],

                images: [ulugbek1, ulugbek2, ulugbek3]
            },

            {
                title: "Musée d'Afrasiab — Samarcande",

                content: `
Le musée d'Afrasiab est un musée archéologique et historique qui préserve les vestiges les plus anciens de l'histoire de Samarcande.

Situé sur le site de l'ancienne cité d'Afrasiab, il constitue l'un des plus importants centres de recherche permettant de découvrir plus de 2 700 ans d'histoire de Samarcande.

Le musée présente des collections exceptionnelles consacrées à l'ancienne Sogdiane, à la Route de la Soie et à la vie quotidienne de l'ancienne Samarcande.
`,

                details: `
Le musée d'Afrasiab a été fondé en 1970 à proximité de la colline d'Afrasiab, où se trouvent les ruines de l'ancienne ville de Samarcande.

Ses collections retracent l'histoire de Samarcande depuis les périodes préislamiques jusqu'au XIIIe siècle.

📌 Principales découvertes :
- Anciennes poteries et objets en céramique
- Pièces de monnaie, armes et objets métalliques
- Ossuaires zoroastriens (urnes funéraires)
- Fragments architecturaux et décorations murales anciennes
- Fresques du palais d'Afrasiab

📌 Les fresques les plus célèbres :
Le trésor le plus précieux du musée est constitué des célèbres « Fresques des Ambassadeurs », datant des VIIe–VIIIe siècles.

Elles représentent notamment :
- Le souverain sogdien Varkhuman
- Des ambassadeurs venus de Chine, de Perse, d'Inde et d'autres régions
- Des processions officielles et des cérémonies d'échange de présents
- Des scènes de chasse et de la vie du palais

📌 À propos des fresques :
Ces peintures murales proviennent des murs d'origine du palais d'Afrasiab. Elles comptent parmi les plus remarquables chefs-d'œuvre de l'art sogdien et figurent parmi les plus anciennes peintures murales en couleur conservées en Asie centrale.

📌 Importance archéologique :
- Les fouilles ont été découvertes par hasard en 1965
- Le site d'Afrasiab constituait le cœur de l'ancienne Samarcande
- Le musée retrace l'histoire de la ville à travers ses différentes couches archéologiques
`,

                facts: [
                    "Situé près de la colline d'Afrasiab à Samarcande",
                    "Fondé en 1970",
                    "Principal centre d'étude de l'histoire de l'ancienne Samarcande",
                    "Présente plus de 2 700 ans d'histoire urbaine",
                    "La cité d'Afrasiab fut détruite par les Mongols au XIIIe siècle",
                    "Les célèbres fresques des VIIe–VIIIe siècles sont son exposition phare",
                    "Les « Fresques des Ambassadeurs » sont mondialement connues",
                    "Conserve des objets de la civilisation sogdienne",
                    "Des ossuaires zoroastriens y sont exposés",
                    "Présente des monnaies, des armes et des objets en céramique",
                    "Abrite des collections liées à la Route de la Soie",
                    "Les fouilles archéologiques ont débuté en 1965",
                    "Afrasiab était le centre historique de l'ancienne Samarcande",
                    "Les fresques témoignent des relations avec la Chine, l'Inde et la Perse",
                    "L'un des musées les plus importants de Samarcande",
                    "Conserve plus de 20 000 artefacts",
                    "Présente quelques-uns des plus beaux exemples de l'art sogdien",
                    "Les peintures murales originales du palais y sont exposées",
                    "L'un des plus importants musées archéologiques d'Asie centrale",
                    "Situé dans une zone associée au patrimoine mondial de l'UNESCO"
                ],

                images: [
                    afrosiyob1,
                    afrosiyob2,
                    afrosiyob3,
                ]
            },
        ]
    }
}
export default samarkand;